import React from "react";
import { Modal, Form, Input, Button, notification } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../hooks/useAuth";
import { createPunchList } from "../services/punchListsAPI";

const CreatePunchListModal = ({ visible, onClose }) => {
  const { selectedProject } = useAuth();
  const projectId = selectedProject?.project_id;
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const mutation = useMutation({
    mutationFn: createPunchList,
    onSuccess: () => {
      queryClient.invalidateQueries(["punch-lists", projectId]);
      onClose();
      form.resetFields();
      notification.success({ message: "Punch list created successfully" });
    },
    onError: (error) => {
      notification.error({
        message: "Failed to create punch list",
        description: error.message,
      });
    },
  });

  const handleCreatePunchList = (values) => {
    const punchListData = {
      ...values,
      project_id: projectId,
    };
    mutation.mutate(punchListData);
  };

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Create Punch List"
      open={visible}
      onCancel={handleClose}
      footer={null}
    >
      <Form form={form} onFinish={handleCreatePunchList} layout="vertical">
        <Form.Item
          label="Title"
          name="title"
          rules={[{ required: true, message: "Please input the title!" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={mutation.isPending}
            className="w-full"
          >
            Create Punch List
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreatePunchListModal;
